import { render, staticRenderFns } from "./StopCandidates.vue?vue&type=template&id=655861d3"
import script from "./StopCandidates.vue?vue&type=script&lang=js"
export * from "./StopCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655861d3')) {
      api.createRecord('655861d3', component.options)
    } else {
      api.reload('655861d3', component.options)
    }
    module.hot.accept("./StopCandidates.vue?vue&type=template&id=655861d3", function () {
      api.rerender('655861d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/StopCandidates.vue"
export default component.exports